import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { Talent, talentIsDeactivated } from "../../../talents/talentAPI";
import {
  selectTalentById,
  updateVehicleAvailable,
} from "../../../talents/talentsSlice";
import { AccessRightContext } from "../../../user/AccessRightProvider";

const TalentVehicleAvailable = () => {
  const { t } = useTranslation("talentProfile");

  const { canEditTalentProfile } = useContext(AccessRightContext);

  const { talentId } = useParams();
  const talent = useAppSelector(
    (state) => selectTalentById(state, talentId as string) as Talent,
  );

  const vehicleAvailable = talent.vehicleAvailable?.value ?? null;
  const version = talent.vehicleAvailable?.version ?? 0;

  const dispatch = useAppDispatch();

  const onChange = (checked: boolean) => {
    if (!talentId) return;

    const payload = {
      talentId: talentId,
      version: version,
      vehicleAvailable: checked,
    };

    dispatch(updateVehicleAvailable(payload));
  };

  return (
    <Grid container columnSpacing={2} marginTop="1.5rem">
      <Grid
        item
        container
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
      />
      <Grid item xs={9}>
        <Typography mb={0.5}>
          {t("talentProfile:talentVehicleInUse")}
        </Typography>
        <RadioGroup
          name="talentVehicleAvailable"
          value={vehicleAvailable}
          onChange={(event) => onChange(event.target.value === "true")}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
          }}
        >
          <FormControlLabel
            value="true"
            control={<Radio />}
            label={t("common:yes")}
            disabled={!canEditTalentProfile || talentIsDeactivated(talent)}
          />
          <FormControlLabel
            value="false"
            control={<Radio />}
            label={t("common:no")}
            disabled={!canEditTalentProfile || talentIsDeactivated(talent)}
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default TalentVehicleAvailable;
